<script>
import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import verigirisdurumlari from './VeriGirisDurumlari.vue';
import birimbazlirapor from './BirimBazliRapor.vue';
import eylembazlirapor from './EylemBazliRapor.vue';
import kurumbazlirapor from './KurumBazliRapor.vue';
import eylemskorlari from './EylemSkorlari';
import grupbazlirapor from './GrupBazli';
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import kontrolortami from "./KontrolOrtamiRapor"
export default {
    mixins: [Api, Sabit],
    page: {
        title: "Soru Formu Raporları",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Loader,
        Layout,
        PageHeader,
        verigirisdurumlari,
        birimbazlirapor,
        eylembazlirapor,
        kurumbazlirapor,
        eylemskorlari,
        grupbazlirapor,
        BirimSecimi,
        kontrolortami

    },
    data() {
        return {
            title: this.$t("StrKontrolGirisRapor.Title"),
            items: [
                {
                    text: this.$t("StrKontrolGirisRapor.Page.Anasayfa"),
                    href: "/",
                },
                {
                    text: this.$t("StrKontrolGirisRapor.Page.UstMenu"),
                    active: true,
                },
                {
                    text: this.$t("StrKontrolGirisRapor.Title"),
                    active: true,
                },
            ],
            DefaultPage: 1,
            Page: {
                PageNumber: "1",
                PageSize: "10",
                PageDataSize: "1",
            },
            Message: {
                position: "",
                icon: "",
                title: "",
                showConfirmButton: false,
                timer: 1500,
            },
            TableData: {},
            ComboboxRevizeDonemler: [],
            ComboboxBirimler: [],
            Birimler: [],
            ComboboxIcKontrolDonemler: [],
            Tablo: null,
            Filter: {
                RevizeDonemId: "",
                BirimId: "",
                IcKontrolDonem: "",
            },
        };
    },

    validations: {
        Filter: {
            RevizeDonemId: { required },
            BirimId: {},
            IcKontrolDonem: {}

        },
    },
    methods: {
        Get() { },
        donemickontrol_combo_yukle(revizeDonemId) {
            let Page = {
                PageNumber: "1",
                PageSize: "9999",
            };
            this.ComboboxIcKontrolDonemler = [];
            let Filter = "&UstId=" + revizeDonemId;
            this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: Filter }).then((res) => {
                this.ComboboxIcKontrolDonemler = res.Data;
            });
        },
    Secilmis_Idler(secilmis) {
      this.Filter.BirimId=secilmis;    
    },
        verigiris_yukle() {
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null) {
                this.Tablo = 1;

            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo1Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 2000;
                Vue.swal(this.Message);
            }
        },
        birimbazli_yukle(){
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null && this.Filter.BirimId != "" && this.Filter.BirimId != null ) {
                this.Tablo = 2;

            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo2Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 3000;
                Vue.swal(this.Message);
            }
        },
        eylembazli_yukle(){
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null) {
                this.Tablo = 3;

            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo3Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 3000;
                Vue.swal(this.Message);
            }
        },
        kurumbazli_yukle(){
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null) {
                this.Tablo = 4;

            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo4Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 3000;
                Vue.swal(this.Message);
            }
        },
        eylemskorlari_yukle(){
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null) {
                this.Tablo = 5;

            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo5Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 3000;
                Vue.swal(this.Message);
            }
        },
        grupbazli_yukle(){
            if (this.Filter.RevizeDonemId != "" && this.Filter.RevizeDonemId != null && this.Filter.IcKontrolDonem != "" && this.Filter.IcKontrolDonem != null) {
                this.Tablo = 6;
            } else {
                this.Message.position = "center";
                this.Message.icon = "warning";
                this.Message.title = this.$t('StrKontrolGirisRapor.Mesajlar.Tablo6Mesaj');
                this.Message.showConfirmButton = false;
                this.Message.timer = 3000;
                Vue.swal(this.Message);
            }
        },
        kontrolortami_yukle(){

                this.Tablo = 7;


        }

    },
    created() {
        this.Get();
        let Page = {
            PageNumber: "1",
            PageSize: "9999",
        };
        let Filter = "&Tip=1561";
        let Tip = [];
        this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: Filter }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
                if (res.Data[i].Kod == 3 || res.Data[i].Kod == 4) {
                    Tip.push(res.Data[i].Id);
                }
            }
            let altsorgu = "&UstIdDoluMu=false&Approval=true";
            let tipler = "";
            for (var s = 0; s < Tip.length; s++) {
                tipler = tipler + "&TipId=" + Tip[s];
            }
            altsorgu = altsorgu + tipler;
            this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
                    this.ComboboxRevizeDonemler.push(res.Data[i]);
                }
            });
        });

        this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => {
            this.ComboboxBirimler = res.Data;
            console.log(res.Data)
        });
        this.ActionsFilterGet({"Service":"OBirim/GetTreeByAnaBirim", "Page":Page , Filter: "&GetProgramlarVeBolumler=false"}).then((res) => {
          this.Birimler = [];
          for(var Data in res.Data){
            if(res.Data[Data].children != null){
                for(var Birim in res.Data[Data].children){
                    this.Birimler.push(res.Data[Data].children[Birim])
                }
            }
          }
        });
    },

};
</script>

<template>
    <Loader>
        <Layout>
            <PageHeader :title="title" :items="items" />
            <div class="row">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <b-form-group class="mb-3" id="donemler" label="" label-for="text">
                                        <select v-model="Filter.RevizeDonemId"
                                            @change="donemickontrol_combo_yukle(Filter.RevizeDonemId)"
                                            class="form-select" type="text">
                                            <option value="">{{ $t('StrKontrolGirisRapor.Filtreleme.DonemId') }}
                                            </option>
                                            <option v-for="DonemVerileri in ComboboxRevizeDonemler"
                                                :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                                                {{ DonemVerileri.Aciklama }}
                                            </option>
                                        </select>
                                    </b-form-group>

                                    <b-form-group class="mb-3" id="birimler" label="" label-for="text">
                                        <BirimSecimi
                                        :title="''"
                                        :title_class="'mb-3'"
                                        :closeOnSelect="true"
                                        :sutun="'0'"
                                        :multiple="false"
                                        :YetkiKontrol="1"
                                        :personel_id="null"
                                        :BirimTipId="null"
                                        @Secilmis_Idler="Secilmis_Idler($event)"
                                    />
                                    </b-form-group>

                                    <b-form-group class="mb-3" id="ickontroldonemleri" label="" label-for="text">
                                        <select v-model="Filter.IcKontrolDonem" class="form-select" type="text">
                                            <option value="">{{ $t('StrKontrolGirisRapor.Filtreleme.IcKontrolDonem') }}
                                            </option>
                                            <option v-for="IcKontrolDonem in ComboboxIcKontrolDonemler"
                                                :key="IcKontrolDonem.Id" :value="IcKontrolDonem.Id">
                                                {{ IcKontrolDonem.Aciklama }}
                                            </option>
                                        </select>
                                    </b-form-group>
                                </div>
                                <div class="col-md-7">
                                    <div class="table-responsive">
                                        <table class="table table-nowrap table-centered table-hover mb-0 align-middle">
                                            <tbody>
                                                <tr>
                                                    <td width="500">
                                                        <h5 class="font-size-14 mb-0">

                                                            <a href="javascript: void(0);" @click="verigiris_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.Verigiris')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5 class="font-size-14 mb-0">
                                                        <a href="javascript: void(0);" @click="birimbazli_yukle()"
                                                            class="text-dark">
                                                            <i class="fas fa-print"></i>
                                                            <span style="margin-left: 10px;">{{
                                                                this.$t('StrKontrolGirisRapor.Raporlar.BirimBazli')
                                                            }}</span>
                                                        </a>
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="500">
                                                        <h5 class="font-size-14 mb-0">

                                                            <a href="javascript: void(0);" @click="eylembazli_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.EylemBazli')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                    <td width="500">
                                                        <h5 class="font-size-14 mb-0">
                                                            <a href="javascript: void(0);" @click="kurumbazli_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.KurumBazli')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="500">
                                                        <h5 class="font-size-14 mb-0">
                                                            <a href="javascript: void(0);" @click="eylemskorlari_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.EylemSkorlari')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                    <td width="500">
                                                        <h5 class="font-size-14 mb-0">
                                                            <a href="javascript: void(0);" @click="grupbazli_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.GrupBazli')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                    
                                                </tr>
                                              <tr>
                                                <td width="500">
                                                        <h5 class="font-size-14 mb-0">
                                                            <a href="javascript: void(0);" @click="kontrolortami_yukle()"
                                                                class="text-dark">
                                                                <i class="fas fa-print"></i>
                                                                <span style="margin-left: 10px;">{{
                                                                    this.$t('StrKontrolGirisRapor.Raporlar.KontrolOrtami')
                                                                }}</span>
                                                            </a>
                                                        </h5>
                                                    </td>
                                                    </tr> 
                                            </tbody>
                                        </table>
                                    </div>
                                    <br>
                                    <br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
                <verigirisdurumlari v-if="Tablo==1"
                  :DonemId="Filter.IcKontrolDonem"
                  :Birimler="this.Birimler"
                  :BirimId="Filter.BirimId"
                />   
                <birimbazlirapor v-if="Tablo==2"
                  :DonemId="Filter.RevizeDonemId"
                  :BirimId="Filter.BirimId"
                  :IcKontrolDonemId="Filter.IcKontrolDonem"
                  :Birimler="ComboboxBirimler"
                  :RevizeDonemler="ComboboxIcKontrolDonemler"
                />   
                <eylembazlirapor v-if="Tablo==3"
                  :DonemId="Filter.RevizeDonemId"
                  :IcKontrolDonemId="Filter.IcKontrolDonem"
                  :Donemler ="ComboboxIcKontrolDonemler"
                /> 
                <kurumbazlirapor v-if="Tablo==4"
                  :DonemId="Filter.RevizeDonemId"
                  :IcKontrolDonemId="Filter.IcKontrolDonem"
                  :Donemler ="ComboboxIcKontrolDonemler"
                />     
                <eylemskorlari v-if="Tablo==5"
                  :DonemId="Filter.RevizeDonemId"
                  :IcKontrolDonemId="Filter.IcKontrolDonem"
                  :Donemler ="ComboboxIcKontrolDonemler"
                />    
                <grupbazlirapor v-if="Tablo==6"
                :DonemId="Filter.RevizeDonemId"
                  :IcKontrolDonemId="Filter.IcKontrolDonem"
                /> 
                <kontrolortami v-if="Tablo==7"
                /> 

            </div>
          </div>
        </div>
      </div>
        </Layout>
    </Loader>
</template>
